<template>
  <v-container :style="themeVars">
    <v-row dense class="mt-9" v-if="loading" alig="center" justify="center">
      <v-progress-circular
        indeterminate
        color="primary-500"
      ></v-progress-circular>
    </v-row>
    <v-row dense class="mt-9" v-else>
      <v-col cols="12" md="10" class="d-flex align-center">
        <v-form v-model="valid" ref="form">
          <v-card
            elevation="1"
            style="background-color: transparent"
            min-height="10vh"
            min-width="70vw"
          >
            <v-card-text>
              <v-file-input
                v-model="avatar"
                ref="fileInput"
                id="fileInput"
                hide-input
                accept="image/*"
                style="visibility: hidden"
              />
              <v-row dense>
                <v-col
                  cols="12"
                  md="3"
                  class="d-flex align-start justify-center"
                >
                  <v-avatar
                    color="primary-500"
                    size="200"
                    @click="triggerFileInput"
                    class="cursor-pointer profile-avatar"
                  >
                    <v-img
                      v-if="hasAvatar"
                      cover
                      :src="profile.avatar"
                      class="profile-avatar__image"
                    />
                    <span v-else class="text-h2 white--text">
                      {{ initials }}
                    </span>
                  </v-avatar>
                </v-col>
                <v-col class="d-flex flex-column justify-center">
                  <span
                    class="text-h4"
                    style="color: var(--customer-primary)"
                    >{{ profile.full_name }}</span
                  >
                  <strong class="text-h5 mt-2"
                    >Modalidade: <span class="text-h6">Dupla</span></strong
                  >
                  <strong class="text-h5"
                    >Frequência: <span class="text-h6">2x Semana</span></strong
                  >
                  <strong class="text-h5"
                    >Professor/Tutor:
                    <span class="text-h6">{{
                      profile.tutor ? profile.tutor.name : "-"
                    }}</span></strong
                  >
                  <strong class="text-h5"
                    >Nível:
                    <span
                      class="text-h6"
                      :class="profile.pendingInfo ? 'alert' : 'gradient'"
                      >{{ profile.englishLevel }}</span
                    >
                  </strong>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  sm="10"
                  class="d-flex align-center justify-end"
                >
                  <v-btn
                    large
                    rounded
                    outlined
                    color="primary-500"
                    class="mr-3"
                    @click="returnToHome"
                  >
                    <v-img
                      contain
                      src="@/assets/icons/undo.svg"
                      class="mr-3"
                    ></v-img>
                    <span style="text-transform: none">Voltar</span>
                  </v-btn>
                  <v-btn
                    large
                    rounded
                    color="primary-500"
                    :loading="loadingSave"
                    @click="submit"
                  >
                    <v-img
                      contain
                      src="@/assets/icons/refresh.svg"
                      class="mr-3"
                    ></v-img>
                    <span class="white--text" style="text-transform: none"
                      >Atualizar</span
                    >
                  </v-btn>
                  <v-btn
                    v-if="profile.pendingInfo"
                    large
                    rounded
                    color="#e85526"
                    class="ml-3"
                    @click="goToCompleteInfo"
                  >
                    <span class="white--text" style="text-transform: none"
                      >Completar informações</span
                    >
                  </v-btn>
                </v-col>
              </v-row>
              <v-row dense class="mt-8">
                <v-tabs
                  v-model="tab"
                  centered
                  icons-and-text
                  background-color="transparent"
                >
                  <v-row dense>
                    <v-col class="d-flex justify-center">
                      <v-tab href="#tab-1"> Dados Gerais </v-tab>
                    </v-col>
                    <v-col class="d-flex justify-center">
                      <v-tab href="#tab-2"> Disponibilidade </v-tab>
                    </v-col>
                    <v-col class="d-flex justify-center">
                      <v-tab href="#tab-3"> Plano de estudos </v-tab></v-col
                    >
                    <v-col class="d-flex justify-center">
                      <v-tab href="#tab-4"> Financeiro </v-tab></v-col
                    >
                  </v-row>
                  <v-tabs-items
                    v-model="tab"
                    style="background-color: transparent"
                  >
                    <v-tab-item value="tab-1">
                      <v-row dense class="mt-4">
                        <v-card
                          elevation="1"
                          style="background-color: transparent"
                          min-height="10vh"
                          min-width="70vw"
                        >
                          <v-card-text elevation="1">
                            <v-card
                              style="background-color: transparent"
                              elevation="1"
                            >
                              <v-card-text>
                                <v-row dense>
                                  <v-col cols="12" md="4">
                                    <custom-input
                                      :outlined="true"
                                      v-model="profile.full_name"
                                      label="Nome"
                                      :currentValue="profile.full_name"
                                    />
                                  </v-col>
                                  <v-col cols="12" md="4">
                                    <custom-input
                                      v-model="profile.phone"
                                      :outlined="true"
                                      label="Telefone"
                                      :currentValue="profile.phone"
                                    />
                                  </v-col>
                                  <v-col cols="12" md="4">
                                    <custom-input
                                      :outlined="true"
                                      label="Email"
                                      v-model="profile.email"
                                      :currentValue="profile.email"
                                      :customRule="rules.email"
                                    />
                                  </v-col>
                                </v-row>
                                <v-row dense>
                                  <v-col cols="12" md="4">
                                    <custom-masked-input
                                      :outlined="true"
                                      label="CPF"
                                      :currentValue="profile.document"
                                      :customRule="rules.document"
                                      v-model="profile.document"
                                      :mask="'###.###.###-##'"
                                    />
                                  </v-col>
                                  <v-col cols="12" md="4">
                                    <custom-masked-input
                                      :outlined="true"
                                      label="Data de nascimento"
                                      v-model="profile.birthDate"
                                      :currentValue="profile.birthDate"
                                      :mask="'##/##/####'"
                                    />
                                  </v-col>
                                  <v-col cols="12" md="4">
                                    <custom-input
                                      :outlined="true"
                                      type="password"
                                      label="Senha"
                                      hint="Senha deve ter pelo menos 8 caracteres, incluindo pelo menos uma letra maiuscula, um número e um caractere especial"
                                      :customRule="rules.optionalPwd"
                                    />
                                  </v-col>
                                </v-row>
                                <v-row dense>
                                  <v-col cols="12" md="12">
                                    <v-textarea
                                      label="Bio"
                                      placeholder="Nos fale um pouco sobre você 😁"
                                      :outlined="true"
                                      rows="4"
                                      v-model="profile.bio"
                                    />
                                  </v-col>
                                </v-row>
                                <v-row
                                  dense
                                  align="center"
                                  justify="center"
                                  v-if="profile.underAge"
                                  class="mt-4"
                                >
                                  <strong style="color: #e85526"
                                    >Responsável legal</strong
                                  >
                                </v-row>
                                <div
                                  v-if="profile.underAge"
                                  class="mt-4"
                                  style="
                                    border-style: solid;
                                    border-color: #a0a0a3;
                                    border-width: 1px;
                                    padding: 2vh;
                                    border-radius: 10px;
                                  "
                                >
                                  <v-row dense>
                                    <v-col>
                                      <custom-input
                                        v-model="profile.legalGuardian.name"
                                        :currentValue="
                                          profile.legalGuardian.name
                                        "
                                        :outlined="true"
                                        label="Nome completo"
                                      ></custom-input>
                                    </v-col>
                                    <v-col>
                                      <custom-input
                                        :outlined="true"
                                        label="Email"
                                        :customRule="rules.email"
                                        :currentValue="
                                          profile.legalGuardian.email
                                        "
                                        v-model="profile.legalGuardian.email"
                                      ></custom-input>
                                    </v-col>
                                    <v-col>
                                      <custom-masked-input
                                        label="Número de telefone do responsável"
                                        placeholder="(11)99999-9999"
                                        hint="ex:(11)1234-5678"
                                        :mask="'(##)#####-####'"
                                        :outlined="true"
                                        v-model="profile.legalGuardian.phone"
                                        :currentValue="
                                          profile.legalGuardian.phone
                                        "
                                      />
                                    </v-col>
                                  </v-row>
                                  <v-row dense>
                                    <v-col>
                                      <custom-masked-input
                                        :outlined="true"
                                        label="CPF"
                                        :mask="'###.###.###-##'"
                                        :customRule="rules.document"
                                        :currentValue="
                                          profile.legalGuardian.document
                                        "
                                        v-model="profile.legalGuardian.document"
                                      />
                                    </v-col>
                                    <v-col>
                                      <custom-masked-input
                                        :outlined="true"
                                        label="Data de nascimento"
                                        :mask="'##/##/####'"
                                        :customRule="rules.validDate"
                                        :currentValue="
                                          profile.legalGuardian.birthDate
                                        "
                                        v-model="
                                          profile.legalGuardian.birthDate
                                        "
                                      />
                                    </v-col>
                                    <v-col>
                                      <div><span>Grau de parentesco</span></div>
                                      <div
                                        class="d-flex align-center justify-center"
                                      >
                                        <v-select
                                          outlined
                                          rounded
                                          background-color="#F1F3F5"
                                          :items="parentGrades"
                                          :item-value="`value`"
                                          :item-text="`text`"
                                          v-model="
                                            profile.legalGuardian.kinship
                                          "
                                        />
                                      </div>
                                    </v-col>
                                  </v-row>
                                </div>
                              </v-card-text>
                            </v-card>

                            <v-card
                              style="background-color: transparent"
                              elevation="1"
                            >
                              <v-card-text>
                                <v-row
                                  dense
                                  align="center"
                                  justify="center"
                                  class="mt-6"
                                >
                                  <strong>Endereço</strong>
                                </v-row>

                                <v-row dense class="mt-4">
                                  <v-col cols="12" md="4">
                                    <debounced-input
                                      :outlined="true"
                                      ref="zipCodeInput"
                                      label="CEP"
                                      placeholder="12345678"
                                      hint="Apenas números"
                                      v-model="profile.address.zipCode"
                                      :currentValue="profile.address.zipCode"
                                      @search="getAddressByZipCode"
                                    ></debounced-input>
                                  </v-col>
                                  <v-col cols="12" md="4">
                                    <custom-input
                                      ref="streetInput"
                                      :outlined="true"
                                      label="Logradouro"
                                      :currentValue="profile.address.street"
                                      v-model="profile.address.street"
                                      :placeholder="
                                        loadingAddress
                                          ? 'Carregando...'
                                          : 'Nome da rua'
                                      "
                                    />
                                  </v-col>
                                  <v-col cols="12" md="4">
                                    <custom-input
                                      :outlined="true"
                                      label="Número"
                                      :currentValue="profile.address.number"
                                      v-model="profile.address.number"
                                    />
                                  </v-col>
                                </v-row>
                                <v-row dense>
                                  <v-col cols="12" md="4">
                                    <custom-input
                                      :outlined="true"
                                      label="Complemento"
                                      :currentValue="profile.address.complement"
                                      v-model="profile.address.complement"
                                      :required="false"
                                    />
                                  </v-col>
                                  <v-col cols="12" md="4">
                                    <custom-input
                                      :outlined="true"
                                      ref="neighboorhoodInput"
                                      label="Bairro"
                                      :currentValue="
                                        profile.address.neighboorhood
                                      "
                                      v-model="profile.address.neighboorhood"
                                    />
                                  </v-col>
                                  <v-col cols="12" md="4">
                                    <custom-input
                                      :outlined="true"
                                      label="Cidade"
                                      ref="cityInput"
                                      :currentValue="profile.address.city"
                                      v-model="profile.address.city"
                                    />
                                  </v-col>
                                  <v-col cols="12" md="4">
                                    <custom-input
                                      :outlined="true"
                                      label="Estado (UF)"
                                      ref="provinceInput"
                                      :currentValue="profile.address.province"
                                      v-model="profile.address.province"
                                    />
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </v-card>
                          </v-card-text>
                        </v-card>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item value="tab-2">
                      <v-row dense class="mt-4">
                        <v-card
                          elevation="0"
                          style="background-color: transparent"
                          min-height="10vh"
                          min-width="70vw"
                        >
                          <v-card-text>
                            <v-row dense align="center" justify="center">
                              <span>Horários</span>
                            </v-row>
                            <v-row
                              dense
                              v-for="(available, index) in profile.aviability"
                              :key="index"
                              align="center"
                            >
                              <v-col cols="12" md="4">
                                <div>Dia da semana</div>
                                <v-select
                                  v-model="available.weekDay"
                                  :items="weekDaysItems"
                                  :item-text="`text`"
                                  :item-value="`value`"
                                  outlined
                                  :disabled="!available.editable"
                                />
                              </v-col>
                              <v-col cols="12" md="3">
                                <div>Início</div>
                                <v-select
                                  v-model="available.from"
                                  outlined
                                  :items="hoursItemsHalf"
                                  :disabled="!available.editable"
                                  @change="updateEnd(available)"
                                />
                              </v-col>
                              <v-col cols="12" md="3">
                                <div>Fim</div>
                                <v-select
                                  v-model="available.to"
                                  outlined
                                  :items="hoursItemsHalf"
                                  :disabled="!available.editable"
                                />
                              </v-col>
                              <v-col cols="12" md="2">
                                <v-btn
                                  icon
                                  @click="
                                    removerDisponibilidade(available.id, index)
                                  "
                                  :disabled="!available.editable"
                                >
                                  <v-icon>mdi-delete</v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                            <v-row align="center" justify="center">
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    circle
                                    icon
                                    v-on="on"
                                    v-bind="attrs"
                                    @click="inserirHorario"
                                    ><v-icon>mdi-plus</v-icon></v-btn
                                  >
                                </template>
                                <span>Adicionar horário</span>
                              </v-tooltip>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item value="tab-3">
                      <!-- Aluno sem professor: tutor designado e plano solo. -->
                      <v-row dense v-if="profile.preference === 1" class="mt-4">
                        <v-col cols="12">
                          <v-card outlined style="border-radius: 12px">
                            <v-card-text>
                              <div class="d-flex align-center mb-2">
                                <v-icon color="primary" class="mr-2"
                                  >mdi-account-tie</v-icon
                                >
                                <span class="text-h6" style="font-weight: bold"
                                  >Seu tutor</span
                                >
                              </div>
                              <div v-if="profile.tutor">
                                <p class="mb-1">
                                  <strong>{{ profile.tutor.name }}</strong>
                                </p>
                                <p class="mb-0 grey--text">
                                  Você estuda no formato sem professor, com
                                  acesso a todo o material da plataforma. Seu
                                  tutor acompanha sua jornada.
                                </p>
                              </div>
                              <p v-else class="mb-0 grey--text">
                                Um tutor será designado para você em breve.
                              </p>
                              <p
                                v-if="profile.soloMonthlyValue"
                                class="mt-3 mb-0"
                              >
                                Plano solo:
                                <strong>{{
                                  formatCurrency(profile.soloMonthlyValue)
                                }}</strong>
                                / mês
                              </p>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="12" md="4">
                          <v-card
                            elevation="0"
                            style="background-color: transparent"
                            min-height="10vh"
                            min-width="70vw"
                          >
                            <v-card-text>
                              <v-row dense class="mt-9">
                                <v-col cols="12" md="6">
                                  <span
                                    class="text-h5"
                                    style="font-weight: bold"
                                    >Estude do seu jeito, no seu tempo</span
                                  ></v-col
                                >
                                <v-col cols="12" md="2">
                                  <v-select
                                    label="Nível"
                                    rounded
                                    outlined
                                    :items="englishLevels"
                                    :item-value="`value`"
                                    :item-text="`text`"
                                  ></v-select>
                                </v-col>
                                <v-col cols="12" md="2">
                                  <v-select
                                    label="Modalidade"
                                    rounded
                                    outlined
                                    :items="types"
                                    :item-value="`value`"
                                    :item-text="`text`"
                                  ></v-select>
                                </v-col>
                                <v-col cols="12" md="2">
                                  <v-select
                                    label="Tempo"
                                    rounded
                                    outlined
                                    :items="times"
                                    :item-value="`value`"
                                    :item-text="`text`"
                                  ></v-select>
                                </v-col>
                              </v-row>
                              <v-row dense class="mt-2">
                                <v-col cols="12" md="3">
                                  <v-img
                                    height="50vh"
                                    width="40vw"
                                    contain
                                    src="@/assets/images/connect/booster.webp"
                                  />
                                </v-col>
                                <v-col cols="12" md="9">
                                  <v-row dense>
                                    <v-card
                                      elevation="0"
                                      style="background-color: transparent"
                                      min-height="10vh"
                                      min-width="70vw"
                                    >
                                      <v-card-text>
                                        <v-row dense>
                                          <v-col
                                            cols="12"
                                            md="9"
                                            class="d-flex align-center justify-center"
                                          >
                                            <span class="text-h6"
                                              >Em quanto tempo planeja terminar
                                              o curso ?</span
                                            >
                                          </v-col>
                                        </v-row>
                                        <v-row dense class="mt-4">
                                          <v-col
                                            cols="12"
                                            md="3"
                                            class="d-flex align-center justify-center"
                                          >
                                            <v-card
                                              color="transparent"
                                              width="25vh"
                                              elevation="0"
                                            >
                                              <v-toolbar
                                                elevation="0"
                                                style="
                                                  height: 1vh;
                                                  background-color: #a0a0a3;
                                                "
                                              ></v-toolbar>

                                              <v-card-text>
                                                <v-row
                                                  dense
                                                  align="center"
                                                  justify="center"
                                                  class="mt-2"
                                                >
                                                  <span class="text-h7"
                                                    >Seu plano</span
                                                  ></v-row
                                                >
                                                <v-row
                                                  dense
                                                  align="center"
                                                  justify="center"
                                                  class="mt-2"
                                                >
                                                  <span class="text-h4"
                                                    >5</span
                                                  ></v-row
                                                >
                                                <v-row
                                                  dense
                                                  align="center"
                                                  justify="center"
                                                  class="mt-2"
                                                >
                                                  <span class="text-h7"
                                                    >Anos</span
                                                  ></v-row
                                                ><v-row
                                                  dense
                                                  align="center"
                                                  justify="center"
                                                  class="mt-2"
                                                >
                                                  <span class="text-h6"
                                                    >R$ 120/Mês</span
                                                  ></v-row
                                                ><v-row
                                                  dense
                                                  align="center"
                                                  justify="center"
                                                  class="mt-2"
                                                >
                                                  <v-btn
                                                    rounded
                                                    outlined
                                                    disabled
                                                  >
                                                    <span
                                                      class="text-h7"
                                                      style="
                                                        text-transform: none;
                                                      "
                                                      >Atual</span
                                                    >
                                                  </v-btn></v-row
                                                >
                                              </v-card-text>
                                            </v-card>
                                          </v-col>
                                          <v-col
                                            cols="12"
                                            md="3"
                                            class="d-flex align-center justify-center"
                                          >
                                            <v-card
                                              color="transparent"
                                              width="25vh"
                                              elevation="0"
                                            >
                                              <v-toolbar
                                                elevation="0"
                                                class="primary-500"
                                                style="height: 1vh"
                                              ></v-toolbar>

                                              <v-card-text>
                                                <v-row
                                                  dense
                                                  align="center"
                                                  justify="center"
                                                  class="mt-2"
                                                >
                                                  <span
                                                    class="text-h7"
                                                    style="
                                                      color: var(
                                                        --customer-primary
                                                      );
                                                    "
                                                    >Booster</span
                                                  ></v-row
                                                >
                                                <v-row
                                                  dense
                                                  align="center"
                                                  justify="center"
                                                  class="mt-2"
                                                >
                                                  <span
                                                    class="text-h4"
                                                    style="
                                                      color: var(
                                                        --customer-primary
                                                      );
                                                    "
                                                    >3</span
                                                  ></v-row
                                                >
                                                <v-row
                                                  dense
                                                  align="center"
                                                  justify="center"
                                                  class="mt-2"
                                                >
                                                  <span
                                                    class="text-h7"
                                                    style="
                                                      color: var(
                                                        --customer-primary
                                                      );
                                                    "
                                                    >Anos</span
                                                  ></v-row
                                                ><v-row
                                                  dense
                                                  align="center"
                                                  justify="center"
                                                  class="mt-2"
                                                >
                                                  <span
                                                    class="text-h6"
                                                    style="
                                                      color: var(
                                                        --customer-primary
                                                      );
                                                    "
                                                    >R$ 160/Mês</span
                                                  ></v-row
                                                ><v-row
                                                  dense
                                                  align="center"
                                                  justify="center"
                                                  class="mt-2"
                                                >
                                                  <v-btn
                                                    rounded
                                                    color="primary-500"
                                                  >
                                                    <span
                                                      class="text-h7"
                                                      style="
                                                        text-transform: none;
                                                      "
                                                      >Escolher</span
                                                    >
                                                  </v-btn></v-row
                                                >
                                              </v-card-text>
                                            </v-card></v-col
                                          >
                                          <v-col
                                            cols="12"
                                            md="3"
                                            class="d-flex align-center justify-center"
                                          >
                                            <v-card
                                              color="transparent"
                                              width="25vh"
                                              elevation="0"
                                            >
                                              <v-toolbar
                                                elevation="0"
                                                style="
                                                  height: 1vh;
                                                  background-color: #a0a0a3;
                                                "
                                              ></v-toolbar>

                                              <v-card-text>
                                                <v-row
                                                  dense
                                                  align="center"
                                                  justify="center"
                                                  class="mt-2"
                                                >
                                                  <span class="text-h7"
                                                    >Booster</span
                                                  ></v-row
                                                >
                                                <v-row
                                                  dense
                                                  align="center"
                                                  justify="center"
                                                  class="mt-2"
                                                >
                                                  <span class="text-h4"
                                                    >1</span
                                                  ></v-row
                                                >
                                                <v-row
                                                  dense
                                                  align="center"
                                                  justify="center"
                                                  class="mt-2"
                                                >
                                                  <span class="text-h7"
                                                    >Ano</span
                                                  ></v-row
                                                ><v-row
                                                  dense
                                                  align="center"
                                                  justify="center"
                                                  class="mt-2"
                                                >
                                                  <span class="text-h6"
                                                    >R$ 220/Mês</span
                                                  ></v-row
                                                ><v-row
                                                  dense
                                                  align="center"
                                                  justify="center"
                                                  class="mt-2"
                                                >
                                                  <v-btn rounded outlined>
                                                    <span
                                                      class="text-h7"
                                                      style="
                                                        text-transform: none;
                                                      "
                                                      >Escolher</span
                                                    >
                                                  </v-btn></v-row
                                                >
                                              </v-card-text>
                                            </v-card></v-col
                                          >
                                        </v-row>
                                        <v-row dense>
                                          <v-col cols="12" md="2"></v-col>
                                          <v-col
                                            cols="12"
                                            md="5"
                                            class="d-flex align-center justify-center"
                                          >
                                            <span class="text-h7"
                                              >Para mais informações, consulte
                                              nossos
                                              <a
                                                >Termos de Uso e Política de
                                                Privacidade.</a
                                              >
                                              Estamos à disposição para
                                              esclarecer qualquer dúvida.
                                              😊</span
                                            >
                                          </v-col>
                                        </v-row>
                                        <v-row dense>
                                          <v-col cols="12" md="2"></v-col>
                                          <v-col
                                            cols="12"
                                            md="5"
                                            class="d-flex align-center justify-center"
                                            ><v-btn
                                              rounded
                                              outlined
                                              style="text-transform: none"
                                              class="primary-500 white--text"
                                              >Turbinar</v-btn
                                            ></v-col
                                          >
                                        </v-row>
                                      </v-card-text>
                                    </v-card>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item value="tab-4">
                      <v-row dense align="center">
                        <v-col
                          cols="12"
                          md="6"
                          v-for="(card, index) in cards"
                          :key="index"
                        >
                          <Card :data="card" />
                        </v-col>
                        <v-col cols="12" md="5">
                          <div
                            class="addCard d-flex align-center justify-center"
                            style="min-height: 30vh"
                          >
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  plain
                                  v-on="on"
                                  v-bind="attrs"
                                  icon
                                  @click="openCheckout"
                                >
                                  <v-img
                                    contain
                                    width="10vw"
                                    height="10vh"
                                    src="@/assets/icons/card.svg"
                                  />
                                </v-btn>
                              </template>
                              <span>{{
                                cards.length
                                  ? "Substituir cartão de crédito"
                                  : "Adicionar cartão de crédito"
                              }}</span>
                            </v-tooltip>
                          </div>
                          <CheckoutDialog
                            ref="checkout"
                            @saved="loadData"
                          /> </v-col></v-row
                    ></v-tab-item>
                  </v-tabs-items>
                </v-tabs>
              </v-row>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { cpf } from "cpf-cnpj-validator";
import addressAPI from "@/shared/addressApi";
import Card from "@/components/checkout/Card.vue";
import customerApi from "@/shared/pitchCustomerApi";
import Colors from "@/styles/app.module.scss";
import { isBefore, isValid, parse, differenceInYears } from "date-fns";
import CheckoutDialog from "@/components/checkout/CheckoutDialog.vue";
export default {
  name: "CustomerProfile",
  components: {
    Card,
    CheckoutDialog,
  },
  mixins: [],
  props: {},
  computed: {
    themeVars() {
      return {
        "--customer-primary": Colors["primary-500"],
        "--customer-primary-soft": Colors["primary-100"],
      };
    },
    initials() {
      return (
        this.getInitials(this.profile.full_name) ||
        localStorage.getItem("initials") ||
        ""
      );
    },
  },
  data() {
    return {
      loading: true,
      loadingSave: false,
      loadingAddress: false,
      valid: false,
      tab: null,
      hasAvatar: false,
      avatar: null,
      attrs: {
        class: "mb-6",
        boilerplate: true,
        elevation: 2,
      },
      profile: {
        name: "",
        phone: "",
        email: "",
        document: "",
        birthDate: "",
        password: "",
        preference: null,
        tutor: null,
        soloMonthlyValue: null,
        details: {
          skills: {},
          mainContacts: [],
          currentAreas: [],
        },
        address: {
          street: "",
          number: "",
          complement: "",
          neighboorhood: "",
          city: "",
          province: "",
          zipCode: "",
        },
        aviability: [],
      },
      rules: {
        validDate: [(v) => this.validDate(v) || "Data de nascimento inválida."],
        document: [
          (v) => this.validateDocNumber(v) || "Número de documento inválido.",
        ],
        email: [
          (v) => !!v || "Campo obrigatório.",
          (v) => /.+@.+\..+/.test(v) || "Email inválido.",
        ],
        optionalPwd: [
          (v) =>
            this.testPWD(v) ||
            "Senha deve ter pelo menos 8 caracteres, incluindo pelo menos uma letra maiuscula, um número e um caractere especial",
        ],
        password: [
          (v) => !!v || "Campo obrigatório.",
          (v) =>
            /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%*#¢+§])[A-Za-z\d@$!%*#?$§-]{8,}$/.test(
              v
            ) ||
            "Senha deve ter pelo menos 8 caracteres, incluindo pelo menos uma letra maiuscula, um número e um caractere especial",
        ],
        required: [(v) => !!v || "Selecione uma opção."],
      },
      cards: [],
      englishLevels: [
        {
          text: "Beginner 1",
          value: "beginner_1",
        },
        {
          text: "Beginner 2",
          value: "beginner_2",
        },
        {
          text: "Essential 1",
          value: "essential_1",
        },
        {
          text: "Essential 2",
          value: "essential_2",
        },
        {
          text: "Pre-Intermediate 1",
          value: "pre_intermediate_1",
        },
        {
          text: "Pre-Intermediate 2",
          value: "pre_intermediate_2",
        },
        {
          text: "Intermediate 1",
          value: "intermediate_1",
        },
        {
          text: "Intermediate 2",
          value: "intermediate_2",
        },
        {
          text: "Upper 1",
          value: "upper_1",
        },
        {
          text: "Upper 2",
          value: "upper_2",
        },
        {
          text: "Advanced 1",
          value: "Advanced_1",
        },
        {
          text: "Advanced 2",
          value: "advanced_2",
        },
      ],
      types: [
        {
          text: "Conversation",
          value: "ALONE",
        },
        {
          text: "Dupla",
          value: "DUO",
        },
        {
          text: "Trio",
          value: "TRIO",
        },
        {
          text: "Quarteto",
          value: "SQUAD",
        },
      ],
      times: [
        {
          text: "1:00",
          value: "1h",
        },
        {
          text: "1:30",
          value: "1:30h",
        },
      ],
      weekDaysItems: [
        {
          text: "Domingo",
          value: 0,
        },
        {
          text: "Segunda-feira",
          value: 1,
        },
        {
          text: "Terça-feira",
          value: 2,
        },
        {
          text: "Quarta-feira",
          value: 3,
        },
        {
          text: "Quinta-feira",
          value: 4,
        },
        {
          text: "Sexta-feira",
          value: 5,
        },
        {
          text: "Sábado",
          value: 6,
        },
      ],
      parentGrades: [
        { text: "Pai/Mãe", value: 1 },
        { text: "Padrasto/Madrasta", value: 2 },
        { text: "Tio/Tia", value: 3 },
        { text: "Avô/Avó", value: 4 },
        { text: "Responsável legal", value: 5 },
        { text: "Outro", value: 6 },
      ],
      learningWays: [
        "Música",
        "Filmes e Séries",
        "Livros",
        "Estudos",
        "Trabalho",
        "Outras Formas",
        "Amigos",
        "Redes Sociais",
      ],
      currentAreas: [
        "Estudante",
        "Educação",
        "Comércio",
        "Tecnologia",
        "Saúde",
        "Outros",
      ],
      hoursItemsHalf: [
        "06:00",
        "06:30",
        "07:00",
        "07:30",
        "08:00",
        "08:30",
        "09:00",
        "09:30",
        "10:00",
        "10:30",
        "11:00",
        "11:30",
        "12:00",
        "12:30",
        "13:00",
        "13:30",
        "14:00",
        "14:30",
        "15:00",
        "15:30",
        "16:00",
        "16:30",
        "17:00",
        "17:30",
        "18:00",
        "18:30",
        "19:00",
        "19:30",
        "20:00",
        "20:30",
        "21:00",
        "21:30",
        "22:00",
      ],
    };
  },
  watch: {
    "profile.birthDate": {
      handler: function (value) {
        if (value) {
          try {
            const birthDate = parse(value, "dd/MM/yyyy", new Date());

            const difference = differenceInYears(new Date(), birthDate);
            if (difference < 18) {
              this.profile.underAge = true;
              if (!this.profile.legalGuardian) {
                this.$set(this.profile, "legalGuardian", {
                  name: "",
                  kinship: null,
                  document: "",
                  email: "",
                  birthDate: "",
                  phone: "",
                });
              }
            } else {
              this.profile.underAge = false;
            }
          } catch (e) {
            return e;
          }
        }
      },
      deep: true,
    },
    avatar: function (value) {
      if (value) {
        this.profile.avatar = URL.createObjectURL(value);
        this.hasAvatar = true;
      }
    },
  },
  mounted() {
    customerApi.showProfile().then((res) => {
      this.profile = Object.assign({}, res.data);
      if (!this.profile.details) {
        this.profile.details = {
          skills: {},
          mainContacts: [],
          currentAreas: [],
        };
      }
      this.loading = false;
    });
  },
  methods: {
    formatCurrency(value) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(Number(value || 0));
    },
    getInitials(name) {
      const parts = String(name || "")
        .trim()
        .split(/\s+/)
        .filter(Boolean);

      if (parts.length === 0) return "";
      if (parts.length === 1) return parts[0].substring(0, 1).toUpperCase();

      return `${parts[0].substring(0, 1)} ${parts[1]
        .substring(0, 1)
        .toUpperCase()}`;
    },
    isValidAvatarUrl(value) {
      if (!value || typeof value !== "string") return false;

      try {
        new URL(value);
        return true;
      } catch {
        return false;
      }
    },
    buildSavedCards(card, fullName) {
      if (!card || !card.ready) return [];
      return [
        {
          current: true,
          name: card.brand || "Cartão",
          holder: card.holderName || fullName || "",
          maskedNumber: `**** **** **** ${card.last4 || "0000"}`,
          expMonth: "",
          expYear: "",
        },
      ];
    },
    loadData() {
      customerApi.showProfile().then((res) => {
        this.profile = Object.assign({}, res.data);
        this.cards = this.buildSavedCards(res.data.card, res.data.full_name);
        if (!this.profile.details) {
          this.profile.details = {
            skills: {},
            mainContacts: [],
            currentAreas: [],
          };
        }
        this.loading = false;
        this.hasAvatar = this.isValidAvatarUrl(res.data.avatar);
        this.$store.dispatch("setAvatar", res.data.avatar || null);
        this.$store.dispatch("setUser", {
          ...(this.$store.getters.user || {}),
          name: res.data.full_name || this.profile.full_name || "",
          full_name: res.data.full_name || this.profile.full_name || "",
          avatar: res.data.avatar || null,
        });
      });
    },
    testPWD(value) {
      if (!value) return true;
      return /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%*#¢+§])[A-Za-z\d@$!%*#?$§-]{8,}$/.test(
        value
      );
    },
    openCheckout() {
      this.$refs.checkout.open();
    },
    validateDocNumber(doc) {
      return cpf.isValid(doc);
    },
    validDate(d) {
      const inputedDate = parse(d, "dd/MM/yyyy", new Date());
      return isValid(inputedDate) && isBefore(inputedDate, new Date());
    },
    goToCompleteInfo() {
      this.$router.push({ name: "CompletarInformacoes" });
    },
    returnToHome() {
      this.$router.push({
        path: "cockpit",
      });
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.loadingSave = true;
        if (this.avatar) {
          const formData = new FormData();
          formData.append("avatar", this.avatar);
          await customerApi.uploadFiles(formData);
        }

        const payload = {
          ...this.profile,
        };

        delete payload.avatar;

        if (payload.pendingInfo) {
          payload.details = {
            ...payload.details,
            ...payload.details.skills,
          };
        }

        customerApi
          .updateProfile(payload)
          .then(async () => {
            this.$root.$emit("display-alert", {
              text: "Perfil atualizado com sucesso!",
              type: 0,
            });
            await this.loadData();
          })
          .catch((err) => {
            const raw =
              err?.response?.data?.message || err?.data?.message || "";
            const message = Array.isArray(raw) ? raw.join(" ") : raw;
            this.$root.$emit("display-alert", {
              text:
                message ||
                "Não foi possível atualizar o perfil. Verifique os dados de endereço (CEP, logradouro, número, bairro e estado) e tente novamente.",
              type: 1,
            });
          })
          .finally(() => {
            this.loadingSave = false;
          });
      } else {
        this.$root.$emit("display-alert", {
          text: `Por favor preencha todos os campos obrigatórios!`,
          type: 1,
        });
      }
    },
    getAddressByZipCode() {
      if (this.profile.address.zipCode) {
        addressAPI
          .getAddresByZipCode(this.profile.address.zipCode)
          .then(async (res) => {
            this.$refs.streetInput.handleInput(res.data.address);
            this.$refs.neighboorhoodInput.handleInput(res.data.district);
            this.$refs.cityInput.handleInput(res.data.city);
            this.$refs.provinceInput.handleInput(res.data.state);
            this.readOnly = false;
            this.loadingAddress = false;
          })
          .catch(() => {
            this.loadingAddress = false;
            this.readOnly = false;
          });
      }
    },
    triggerFileInput() {
      document.getElementById("fileInput").click();
    },

    updateEnd(av) {
      if (!av.from) return;

      const [h, m] = av.from.split(":").map(Number);
      const d = new Date(2000, 0, 1, h, m);
      // duração padrão de aula: 60 minutos
      d.setMinutes(d.getMinutes() + 60);

      const hh = String(d.getHours()).padStart(2, "0");
      const mm = String(d.getMinutes()).padStart(2, "0");

      const result = `${hh}:${mm}`;
      // só sobrescreve quando o horário calculado existe na lista; caso
      // contrário preserva o valor que o usuário tenha escolhido manualmente.
      if (this.hoursItemsHalf.includes(result)) {
        av.to = result;
      }
    },

    async removerDisponibilidade(id, index) {
      if (id) {
        await customerApi
          .removerDisponibilidade(id)
          .then(() => {
            this.profile.aviability.splice(index, 1);
            this.$root.$emit("display-alert", {
              text: "Disponibilidade atualizada com sucesso!",
              type: 0,
            });
          })
          .catch(() => {
            this.$root.$emit("display-alert", {
              text: `Ocorreu um problema ao atualizar sua disponibilidade, tente novamente mais tarde!`,
              type: 1,
            });
          });
      } else {
        this.profile.aviability.splice(index, 1);
      }
    },

    inserirHorario() {
      if (!Array.isArray(this.profile.aviability)) {
        this.$set(this.profile, "aviability", []);
      }
      this.profile.aviability.push({
        weekDay: null,
        from: null,
        to: null,
        editable: true,
      });
    },
  },
};
</script>
<style scoped>
.header {
  font-family: "Poppins", "Sans-serif";
  font-size: 27.6px;
  font-weight: bold;
}

.regular {
  font-family: "Poppins", "Sans-serif";
  font-size: 16px;
}

.image-col {
  position: relative;
}

.overflow-image {
  position: absolute;
  top: -17.5vh;
  right: 0;
}

.normal {
  text-transform: none;
}

.gradient {
  background: -webkit-linear-gradient(
    var(--customer-primary-soft),
    var(--customer-primary)
  );
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.pulsingText {
  color: #ff5d2a;
  animation: pulse 2s infinite;
  border-radius: 30%;
  padding: 1vh;
}

.alert {
  color: #e85526;
}

.profile-avatar {
  overflow: hidden;
}

.profile-avatar__image {
  width: 100%;
  height: 100%;
}

@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(144, 0, 222, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 1rem rgba(144, 0, 222, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(144, 0, 222, 0);
  }
}
</style>
